import type {PinIdentifier} from './types';

import {getSelectedVendorFromStorage} from 'utils/Helper';

export const getPinVendorId = (): PinIdentifier => {
  const vendorId = getSelectedVendorFromStorage()?.id;

  return typeof vendorId === 'string' || typeof vendorId === 'number' ? vendorId : '0';
};

export const getPinErrorMessage = (error: unknown, fallback: string): string => {
  if (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof error.message === 'string'
  ) {
    return error.message;
  }

  return fallback;
};
